/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el = $(el);

$el.find('[name="date"]').mask('00/00/0000');
$el.find('[name="amount"]').mask('#.##0,00', {reverse: true});
$el.find('[name="institution_document"], [name="provider_document"]').mask('00.000.000/0000-00', {reverse: true});
$el.find('[name="volunteers"]').mask('000000');

const $radioInputs = $el.find('input[type="radio"]');

$radioInputs.on('change', function () {
    const $inputParent    = $(this).parent();
    const $parentSiblings = $inputParent.siblings();

    $parentSiblings.removeClass('active');
    $inputParent.addClass('active');
});

// Upload File
const max_files = 10;
const allowed_mime_types = [
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/rtf',
];

const allowed_size_mb = 30;

const $inputFile = $el.find('#files');
const $btnUpload = $el.find('.btn-upload');
const $load      = $el.find('.load');
const $uploadedFilesWrapper = $el.find('.files-wrapper');

const data = new FormData();
let filesCount = 0;

data.append('content_type', 'solicitation');

$inputFile.on('change', function () {
    const files = $(this).prop('files');

    if(files.length > 0) {
        if((filesCount + files.length) > max_files) {
            alert('Quantidade de arquivos selecionados maior que o permitido (Máximo: '+(max_files - filesCount)+').');
            return;
        } else {
            for(let i = 0; i < files.length; i++) {
                const file = files[i];

                if(allowed_mime_types.indexOf(file.type) == -1) {
                    alert('Erro: Arquivo não permitido (Arquivos permitidos: jpeg, png, doc, docx, pdf, xls, xlsx, ppt, pptx e rtf).');
                    return;
                }

                if(file.size > allowed_size_mb * 1024 * 1024) {
                    alert('Erro: Arquivo com tamanho superior ao permitido ('+allowed_size_mb+' MB).');
                    return;
                }

                data.append('files[]', file);
                filesCount++;
            }
        }

        if(filesCount > 0) {
            $load.show();

            let request = new XMLHttpRequest();
            request.open('POST', siteUploadSolicitation);
            request.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));

            request.upload.addEventListener('progress', function(e) {
                let percent_complete = (e.loaded / e.total) * 100;
            });

            request.addEventListener('load', function(e) {
                const response = JSON.parse(request.response);

                for(let i = 0; i < response.length; i++) {
                    let uploaded_file = response[i];

                    if(!uploaded_file.error) {
                        $uploadedFilesWrapper.append(`
                            <div class="file">
                                <span class="file-name">${uploaded_file.file_item_original_name}</span>
                                <button type="button" class="btn-remove">
                                    <svg class="icon-remove" aria-label="Remover"><use xlink:title="Remover" xlink:href="#svg-plus" /></svg>
                                </button>
                                <input type="hidden" name="attachments[${i}][filename]" value="${uploaded_file.file_item_name}">
                                <input type="hidden" name="attachments[${i}][original_filename]" value="${uploaded_file.file_item_original_name}">
                            </div>
                            <div class="clearfix" >
                        `);

                        $load.hide();
                    }
                }

                if(!allowedToUpload()) {
                    $btnUpload.hide();
                }

                $uploadedFilesWrapper.find('.file').each(function(fileIndex, fileElement) {
                    $(fileElement).find('input').each(function(inputIndex, inputElement) {
                        if(inputIndex == 0) {
                            $(inputElement).attr('name', `attachments[${fileIndex}][filename]`);
                        }
                        if(inputIndex == 1) {
                            $(inputElement).attr('name', `attachments[${fileIndex}][original_filename]`);
                        }
                    });
                });

            });

            request.send(data);
            data.delete('files[]');


        }
    }
});

$(document).on('click', '.btn-remove', function(e) {
    e.preventDefault();
    $(this).parent().remove();

    filesCount--;

    if(allowedToUpload()) {
        $btnUpload.show();
    }
});

function allowedToUpload() {
    return filesCount < max_files;
}
